module.exports = "/images/star-new.svg?a42749718df937470d614efdcc4cd284";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/star-new.svg
// module id = 65
// module chunks = 0